// extracted by mini-css-extract-plugin
export default {"paper":"BotSignals_paper__Ky5+T","pagination":"BotSignals_pagination__1eQ4G"};